module.exports = __webpack_public_path__ + "static/media/silver.36260f66.png";